export default "__VITE_ASSET__CbfK1MGw__"